module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    class: {
      disabled: _vm.loading, 'max-width': true
    }
  }, [_c('h1', [_vm._v("Översättningar")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.generateTranslations()
      }
    }
  }, [_vm._v("Skapa översättningar")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.generateTranslationsFromFiles()
      }
    }
  }, [_vm._v("Skapa översättningar utifrån befintliga översättningar")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.getFile('en')
      }
    }
  }, [_vm._v("Hämta engelsk fil")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.getFile('da')
      }
    }
  }, [_vm._v("Hämta dansk fil")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.uploadFile()
      }
    }
  }, [_vm._v("Ladda upp fil")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ef26802"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Translation.vue
// module id = 916
// module chunks = 0